import {ReloadButton,} from '@flexinet/ui-components';

import {Box,} from '@mantine/core';

import {useSetupIntents} from '../hooks/useSetupIntents.ts';

export const ReloadRecordsButton = () => {

    const {fetchRecords} = useSetupIntents();
    return (
        <Box mx='s'>
            <ReloadButton onClick={() => fetchRecords()}/>
        </Box>
    );
};
